<div class="loaderBackground">
  <div class="loaderContainer">
    <div class="loader" style=" display: block">
      <h4><i class="fas fa-spinner fa-spin fa-2x"></i></h4>
    </div>
    <div class="loaderMessage">
      <h6>{{message}}</h6>
    </div>
  </div>
</div>